import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { Box, Divider, CircularProgress } from "@mui/joy";

import { useRoles } from "../../../../hooks/query";
import FullHeightDataGrid from "../../../Administration/components/FullHeightDataGrid";
import { Button, Alert } from "../../../../shared";
import { columnDef } from "./column-def";
import { Breadcrumb } from "../Create/components";

export default function List() {
    const { useList } = useRoles();
    const listRolesSvc = useList();

    const roles = listRolesSvc.data || [];

    if (listRolesSvc.isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (listRolesSvc.isError) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage={listRolesSvc.error instanceof Error ? listRolesSvc.error.message : "Failed to load roles"} />
            </Box>
        );
    }

    return (
        <Box flex={1} display="flex" flexDirection="column" sx={{ minHeight: 0 }}>
            <Breadcrumb />
            <Divider />
            <Box flex={1} display="flex" flexDirection="column" sx={{ minHeight: 0 }}>
                <FullHeightDataGrid
                    gridData={roles}
                    columnDefs={columnDef}
                    customToolbarActions={
                        <Button
                            variant="soft"
                            size="md"
                            startDecorator={<Plus size={18} />}
                            component={Link}
                            to={"/admin/roles/new"}
                        >
                            New Role
                        </Button>
                    }
                />
            </Box>
        </Box>
    );
}
